import { useContext } from 'react';
import { ToastContext, ToastContextProps } from 'src/modules/common/components/Toast/ToastContext';

export const useToast = (): ToastContextProps => useContext(ToastContext);
